import { OnboarderDoucmentSettingsService } from '@/modules/global-settings/onboarder/services/onboarder-doument-settings.service';
import { make } from 'vuex-pathify';
// Create a new instance of the service
const service = new OnboarderDoucmentSettingsService();
// Creatre state for the module
export const state = {
  onboarderDocuments: []
};
// Create mutations
export const mutations = {
  ...make.mutations(state)
};
// Create actions
export const actions = {
  /**
   * Fetch all onboarding documents
   * @async
   * @param {Object} context - Vuex context
   * @returns {number | undefined} - HTTP status code
   * @private This will set the onboarderDocuments state
   */
  async fetchOnboardingDocuments({ commit }) {
    const result = await service.fetchOnboardingDocuments();
    commit('SET_ONBOARDER_DOCUMENTS', result.data);
    return result.status;
  },

  /**
   * Create a new onboarding document
   * @async
   * @param {Object} context - Vuex context
   * @param {Object} newDocument - New onboarding document
   * @returns {number | undefined} - HTTP status code
   * @private This will refetch the onboarderDocuments state
   */
  async createOnboardingDocument({ dispatch }, newDocument) {
    const result = await service.createOnboardingDocuments(newDocument);
    dispatch('fetchOnboardingDocuments');
    return result.status;
  },

  /**
   * Update an onboarding document
   * @async
   * @param {Object} context - Vuex context
   * @param {Object} payload - Onboarding document ID and updates
   * @param {string} payload.id - Onboarding document ID
   * @param {Object} payload.updates - Onboarding document updates
   * @returns {number | undefined} - HTTP status code
   * @private This will refetch the onboarderDocuments state
   */
  async updateOnboardingDocument({ dispatch }, { id, updates }) {
    const result = await service.updateOnboardingDocuments(id, updates);
    dispatch('fetchOnboardingDocuments');
    return result.status;
  }
};
// Create getters
export const getters = {
  ...make.getters(state),
  activeOnBoarderDocuments(state) {
    return state.onboarderDocuments.filter((d) => d.status == true);
  }
};
